module.exports = __webpack_public_path__ + "static/img/2.6f9a8a14.png";